import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { Subscription } from 'rxjs/Rx';

import { TranslateService } from '@ngx-translate/core';

import { RootService } from '../../service/root.service';

import { User } from '../../module/user/shared/user';
import { ProfileService } from './profile.service';

@Component({

    selector: 'profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {
    @Input() user: User;
    auth={oldPassword:'',newPassword:''};
    @Input() id: number;
    @Input() operation: string;
    roles: any;
    fromRoute: boolean;
    display=false;
    routeEvent: Subscription;
    requestXHR: Subscription;
    requestError: boolean;
    noResult: boolean;

    submittingForm: boolean = false;

    constructor(public rootService: RootService,
        private profileService: ProfileService,
        private route: ActivatedRoute,
        private router: Router,
        private translate: TranslateService) {

        var routeData = this.route.snapshot.data;
        this.fromRoute = routeData['fromRoute'];
        this.operation = routeData['operation'];


    }
    ngOnChanges() {
        if (this.operation == 'read' || this.operation == 'update') {
            if (typeof this.id !== 'undefined') {
                this.getUser();
            }
        }else {
                if (typeof this.id !== 'undefined') {
                this.refreshRequest();
                }

            }
    }
    
    getUser() {
        this.requestError = false;
        this.noResult = false;
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        this.requestXHR = this.profileService.get()
            .subscribe(
            items => {
                if (items.users && items.users.length > 0) {
                    this.user = items.users[0]
                } else {
                    this.noResult = true;
                }
                
            }, //Bind to view
            err => {
                this.requestError = true;
                // Log errors if any
                this.rootService.toast.showErrorCode(err.code);
                //console.log(err);
            });
    }
   
    
    submitForm(form, formElement) {

        if (form.invalid) {
            var firstElement = formElement.nativeElement.querySelector('.ng-invalid');
            var focusElement = firstElement.querySelector('.focusV');
            if (focusElement) {
                focusElement.focus();
            }
            return;
        }
         if(this.submittingForm){
            return;
        }
        this.submittingForm=true;
        this.profileService.update(this.user).subscribe(items => {
            this.submittingForm=false;
            this.rootService.toast.showSuccess(this.translate.instant('form.common.updateItem', { 'item': this.translate.instant('ctrl.user.view.header.one'),'id':this.id  }));
        },err => {
            this.submittingForm=false;
            this.rootService.toast.showErrorCode(err.code)
        });
        
    }

    submitPassword(form, formElement,auth) {

        if (form.invalid) {
            var firstElement = formElement.nativeElement.querySelector('.ng-invalid');
            var focusElement = firstElement.querySelector('.focusV');
            if (focusElement) {
                focusElement.focus();
            }
            return;
        }
        
        this.rootService.changePasswordI(auth);
        
    }

    refreshRequest() {
        
            this.getUser();
        
    }
    ngOnInit() {
        
                this.getUser();

    }
    ngOnDestroy() {
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        if (this.routeEvent) {
            this.routeEvent.unsubscribe();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/profile/profile.component.ts